var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwoRateActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.5H16.7639C18.2507 12.5 19.2177 10.9354 18.5528 9.60557L15.0528 2.60557C14.714 1.92801 14.0215 1.5 13.2639 1.5H9.24621C9.08269 1.5 8.91978 1.52005 8.76114 1.55972L5 2.5M12 12.5V17.5C12 18.6046 11.1046 19.5 10 19.5H9.90453C9.40497 19.5 9 19.095 9 18.5955C9 17.8812 8.78857 17.1828 8.39234 16.5885L5 11.5V2.5M12 12.5H10M5 2.5H3C1.89543 2.5 1 3.39543 1 4.5V10.5C1 11.6046 1.89543 12.5 3 12.5H5.5",
    stroke: "#6B7280",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoRateActive);
export default __webpack_public_path__ + "static/media/twoRateActive.714435005a76dffbbbd1684fbb81a31d.svg";
export { ForwardRef as ReactComponent };